import { Box } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { routes } from 'utils/routing';

import {
  OrderIssuesContainer,
  OrderIssuesDetails,
  OrderIssuesHeading,
  OrderIssuesText,
  StyledButton,
} from './styled';

export const NeedHelpLarge = ({ children }: { children: React.ReactNode }) => {
  const { formatMessage } = useIntl();

  return (
    <OrderIssuesContainer>
      <OrderIssuesDetails>
        <OrderIssuesHeading>{formatMessage({ id: 'needHelp' })}</OrderIssuesHeading>
        <OrderIssuesText>
          {formatMessage({ id: 'issuesDuringExperience' })}&nbsp;
          {formatMessage({ id: 'visitSupport' }).toLowerCase()}
        </OrderIssuesText>
      </OrderIssuesDetails>
      <Box>
        <StyledButton to={routes.support}>{formatMessage({ id: 'visitSupport' })}</StyledButton>
      </Box>
      {children}
    </OrderIssuesContainer>
  );
};
